import { AxiosRequestConfig } from "axios";
import api from "../api-instance";
import {
  User,
  PatchUser,
  NotificationConfiguration,
  WhatsappNotificationConfiguration,
  Role,
} from "../../../modules/users/types";

const ROUTE = "/User";

export async function getUsers(): Promise<{ data: User[]; total: number }> {
  // page: number = 1,
  // search: string = "",
  // params?: Partial<User>,
  // limit: number = 1000
  //TODO: Aplicar parâmetros quando a paginação e ordenação do Back End estiver finalizada

  const config: AxiosRequestConfig = {
    // params: {
    //   _page: page,
    //   _limit: limit,
    //   q: search,
    //   ...params,
    // },
  };

  const result = await api.get(ROUTE, config);
  return {
    data: result.data.users,
    total: parseInt(result.headers["x-total-count"]),
  };
}
export async function getUser(id: string): Promise<User> {
  const result = await api.get(`${ROUTE}/${id}`);
  return result.data.user;
}
type PostUser = {
  name: string;
  email: string;
  cpf: string | null;
  phone: string | null;
  clients: PostUserClient[];
};
type PostUserClient = {
  clientId: string;
  clientName: string;
  usinas: string[];
  roles: string[];
};
export async function postUser(user: PostUser): Promise<User> {
  const { phone, ...rest } = user;
  const userInput = {
    ...rest,
  };
  const result = await api.post(ROUTE, userInput);
  return result.data;
}
// export async function postUser(user: PostUser) {
//   const result = await api.post(ROUTE, user);
//   return result.data;
// }
export async function patchUser(
  userId: string,
  user: PatchUser
): Promise<User> {
  const result = await api.patch(`${ROUTE}/${userId}`, user);
  return result.data;
}
export async function patchUserName(
  userId: string,
  name: string
): Promise<{ id: string }> {
  const result = await api.patch(`${ROUTE}/${userId}/update-name`, name, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return result.data;
}
export async function patchUserInfos(
  userId: string,
  email: string | null,
  phone: string | null,
  cpf: string | null
): Promise<{ id: string }> {
  const result = await api.patch(`${ROUTE}/${userId}/update-infos`, {
    email: email,
    phone: phone,
    cpf: cpf,
  });
  return result.data;
}

export async function deleteUser(id: string): Promise<{ id: string }> {
  const result = await api.delete(`${ROUTE}/${id}`);
  return result.data;
}

export async function resetPassword(email: string): Promise<{ id: string }> {
  const result = await api.patch(`${ROUTE}/reset-password`, undefined, {
    params: {
      email,
    },
  });
  return result.data;
}

export async function removeUsina(
  email: string,
  clientId: string,
  usinaId: string
) {
  const result = await api.patch(`${ROUTE}/${email}/remove-usina`, {
    clientId: clientId,
    usinaId: usinaId,
  });
  return result.data;
}
export async function addUsina(
  email: string,
  clientId: string,
  usinaId: string
) {
  const result = await api.patch(`${ROUTE}/${email}/add-usina`, {
    clientId: clientId,
    usinaId: usinaId,
  });
  return result.data;
}
// {
//   "clientId": "6509eb1e523d64d3689d0227",
//   "role": "Tecnico"
// }
export async function removeRole(
  email: string,
  clientId: string,
  role: string
) {
  const result = await api.patch(`${ROUTE}/${email}/remove-role`, {
    clientId: clientId,
    role: role,
  });
  return result.data;
}
export async function addRole(email: string, clientId: string, role: string) {
  const result = await api.patch(
    `${ROUTE}/${email}/add-role`,

    { clientId: clientId, role: role }
  );
  return result.data;
}
export async function removeClient(userId: string, clientId: string) {
  const result = await api.delete(`${ROUTE}/${userId}/clients/${clientId}`);
  return result.data;
}
export async function addClient(userId: string, clientId: string) {
  const result = await api.post(`${ROUTE}/${userId}/clients/${clientId}`);
  return result.data;
}
export async function notificationConfiguration(
  userId: string,
  configuration: NotificationConfiguration
) {
  const result = await api.patch(
    `${ROUTE}/${userId}/notification-configuration`,
    {
      configuration: configuration,
    }
  );
  return result.data;
}

export async function updateWhatsappNotificationConfiguration(
  userEmail: string,
  clientId: string,
  configuration: WhatsappNotificationConfiguration
) {
  const { canReceiveWhatsappNotification, ...rest } = configuration;
  const result = await api.patch(
    `${ROUTE}/${userEmail}/whatsapp-notification-configuration`,
    {
      configuration: rest,
      clientId: clientId,
    }
  );
  return result.data;
}

export async function changePassword(newPassword: string) {
  const result = await api.put(`${ROUTE}/change-password`, {
    newPassword: newPassword,
  });
  return result.data;
}

export async function getAllRoles(): Promise<Role[]> {
  const result = await api.get(`${ROUTE}/All/Roles`);

  return result.data.roles;
}

export async function resetUsersLayouts() {
  const result = await api.patch(`${ROUTE}/reset-all-users-layout`);
  return result.data;
}

export async function resetLayoutToFalse(userId: string) {
  const result = await api.patch(`${ROUTE}/set-reset-layout-to-false/${userId}`);
  return result.data;
}
export async function updateUserLastActivity(userId: string) {
  const result = await api.patch(`${ROUTE}/set-last-activity/${userId}`);
  return result.data;
}
